/**
 *
 * WidgetHistoryEvolution
 *
 */

import React, { Fragment } from "react"
import Chart from "react-apexcharts"
import "./index.less"
import randomColor from "randomcolor"
import { remove } from "lodash"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

/* eslint-disable react/prefer-stateless-function */
class WidgetHistoryEvolution extends React.Component {
  chartOptionsBase = {
    chart: {
      id: "apexchart-clima",
      stacked: false,
      toolbar: { show: false },
    },
    legend: { show: false },
    dataLabels: { enabled: false },
    plotOptions: { line: { curve: "smooth" } },
    markers: {
      size: 3,
      colors: [],
      strokeColor: [],
      strokeWidth: 5,
      strokeOpacity: 0.2,
      fillOpacity: 1,
      shape: "circle",
      radius: 2,
      offsetX: 0,
      offsetY: 0,
      hover: {
        size: 4,
        sizeOffset: 1,
      },
    },
    xaxis: {
      type: "category",
      lines: { show: true },
      labels: {
        maxWidth: 50,
        show: true,
        style: {
          fontSize: "10px",
          colors: "#A9A9A9",
        },
        offsetX: 0,
      },
      categories: [],
      axisTicks: { show: false },
      axisBorder: {
        show: true,
        height: 1,
        color: "#EAF0F4",
      },

      tooltip: { enabled: false },
    },
    yaxis: {
      min: 0,
      max: 100,
      tickAmount: 5,
      opposite: false,
      decimalsInFloat: false,
      lines: { show: true },
      labels: {
        align: "right",
        style: {
          color: "#A9A9A9",
          fontSize: "10px",
          cssClass: "apexcharts-yaxis-label",
        },
        formatter(val, index) {
          return `${val}%`
        },
      },
      axisTicks: { show: false },
    },
    toolbar: { show: false },
    stroke: {
      show: true,
      curve: "straight",
      lineCap: "butt",
      colors: ["#4C83FE", "#55C8AE"],
      width: 1.3,
      dashArray: 0,
    },
    grid: { borderColor: "#EAF0F4" },
    tooltip: {
      shared: false,
      custom: ({ series, seriesIndex, dataPointIndex, w }) => {
        const { outcomes } = this.state
        let nameVariable = "-"
        outcomes.map((outcome) => {
          const exist = outcome.serie.find(
            (serieFind) => serieFind === series[seriesIndex][dataPointIndex]
          )
          if (exist) {
            nameVariable = outcome.name
          }
        })

        if (seriesIndex === 0) {
          return (
            `<div class="speech-bubble"><span><b> ${
              this.props.hasLeader ? "Liderazgo " : "Clima Laboral "
            }</b>
            ${
              series[seriesIndex][dataPointIndex] === 99 ||
              series[seriesIndex][dataPointIndex] === 99.1
                ? 100
                : Math.trunc(series[seriesIndex][dataPointIndex])
            }%` +
            `</span>` +
            `</div>`
          )
        }
        if (seriesIndex === 1) {
          return (
            `<div class="speech-bubble"><span><b>Tasa de Respuesta </b> 
            ${
              series[seriesIndex][dataPointIndex] === 99 ||
              series[seriesIndex][dataPointIndex] === 99.1
                ? 100
                : Math.trunc(series[seriesIndex][dataPointIndex])
            }%` +
            `</span>` +
            `</div>`
          )
        }
        if (seriesIndex === 2) {
          return (
            `${'<div class="speech-bubble">' +
              "<span>" +
              "<b>" +
              "Engagement " +
              "</b>"}${
              series[seriesIndex][dataPointIndex] === 99 ||
              series[seriesIndex][dataPointIndex] === 99.1
                ? 100
                : Math.trunc(series[seriesIndex][dataPointIndex])
            }%` +
            `</span>` +
            `</div>`
          )
        }
        if (seriesIndex > 2) {
          return (
            `${'<div class="speech-bubble">' +
              "<span>" +
              "<b>"}${nameVariable}</b>` +
            ` ${
              series[seriesIndex][dataPointIndex] === 99
                ? 100
                : Math.trunc(series[seriesIndex][dataPointIndex])
            }%` +
            `</span>` +
            `</div>`
          )
        }
      },
      fixed: {
        enabled: true,
        position: "topRight",
        offsetX: 0,
      },
    },
    fill: {
      colors: ["#4C83FE", "#EAF0F4"],
      type: "gradient",
      lines: { show: true },
      gradient: {
        shadeIntensity: 0.8,
        opacityFrom: 0.4,
        opacityTo: 0.2,
      },
      pattern: {
        style: "verticalLines",
        width: 6,
        height: 6,
        strokeWidth: 2,
      },
    },
  }

  constructor(props) {
    super(props)
    this.state = {
      series: {},
      numero: 3,
      hasEngagementByDivision: false,
      colors: ["#4C83FE", "#55C8AE"],
      fillColors: ["#4C83FE", "#EAF0F4"],
      info: {
        dates: ["Set. 2018", "May. 2018"], // fechas de las mediciones
        reportType: "clima", // clima, liderazgo, engagement
        variables: [
          {
            id: 1,
            show: true,
            name: "Clima Laboral",
            data: [64, 64], // medicion en diferentes momentos
            type_chart: "clima", // clima o tasa o engagement
          },
          {
            id: 2,
            show: true,
            name: "Tasa de Respuesta",
            data: [77, 99],
            type_chart: "tasa", // clima o tasa o engagement
          },
        ],
      },
      outcomes: [
        {
          id: 0,
          name: "eNPS (Recomendación)",
          color: "#CE92CC",
          show: false,
          serie: [12, 98, 16],
        },
        {
          id: 1,
          name: "Motivación",
          color: "#88CF87",
          show: false,
          serie: [23, 58, 99],
        },
        {
          id: 2,
          name: "Orgullo",
          color: "#F46C6C",
          show: false,
          serie: [40, 68, 57],
        },
        {
          id: 3,
          name: "Compromiso",
          color: "#F9A252",
          show: false,
          serie: [100, 3, 36],
        },
        {
          id: 4,
          name: "Lealtad",
          color: "#F9D252",
          show: false,
          serie: [99, 12, 78],
        },
      ],
      chartOptions: this.chartOptionsBase,
    }
  }

  UNSAFE_componentWillMount = () => {
    const hasEngagementDiv = this.setOutcomes()
    this.formatDatta(hasEngagementDiv)
    this.setDefaultColors(hasEngagementDiv)
  }

  formatDatta = (hasEngagementDiv) => {
    const newSeries = []
    let newElements
    let equals
    const { data, hasEngagement } = this.props
    data.variables.map((item, index) => {
      const validation =
        (hasEngagement || hasEngagementDiv) && item.type_chart === "engagement"
      if (
        item.type_chart === "clima" ||
        item.type_chart === "tasa" ||
        item.type_chart === "liderazgo" ||
        validation
      ) {
        newElements = []
        item.data.map((element) => {
          return element === 100
            ? newElements.push(99)
            : newElements.push(element)
        })
        equals =
          newElements
            .join("")
            .split(newElements[0])
            .join("").length === 0

        if (equals && newElements) {
          newElements[0] += 0.1
        }

        newSeries.push({ data: newElements, name: item.name, id: index })
      }
    })
    this.setState({ series: newSeries })
  }

  setDefaultColors = (hasEngagementDiv) => {
    const { hasEngagement } = this.props
    const colorsDefault = ["#4C83FE", "#55C8AE"]
    const colorsFill = ["#4C83FE", "#EAF0F4"]
    if (hasEngagement || hasEngagementDiv) {
      colorsDefault.push("#45A2FC")
      colorsFill.push("#EAF0F4")
    }
    this.setState({
      chartOptions: {
        ...this.state.chartOptions,
        markers: {
          ...this.state.chartOptions.markers,
          colors: colorsDefault,
          strokeColor: colorsDefault,
        },
        stroke: {
          ...this.state.chartOptions.stroke,
          colors: colorsDefault,
        },
        fill: {
          ...this.state.chartOptions.fill,
          colors: colorsFill,
        },
      },
      colors: colorsDefault,
      fillColors: colorsFill,
    })
  }

  setOutcomes = () => {
    const { data } = this.props
    let { outcomes } = this.state
    if (data.variables[2].outcomes.length > 0) {
      // hasEngagement || hasEngagementByDivision the object has outcomes
      outcomes = data.variables[2].outcomes
      outcomes.map((outcome, index) => {
        outcomes[index].show = false
        if (!outcome.color) {
          outcomes[index].color = randomColor()
        }
      })
      this.setState({ outcomes, hasEngagementByDivision: true })
      return true
    }
    return false
  }

  componentDidMount = () => {
    const { data } = this.props

    this.setState({
      chartOptions: {
        ...this.state.chartOptions,
        xaxis: {
          ...this.state.chartOptions.xaxis,
          categories: data.dates,
        },
      },
    })
  }

  showLine = (outcome) => {
    const newSeries = []
    const { colors, fillColors } = this.state

    this.state.series.map((s) => {
      newSeries.push({ data: s.data, name: s.name })
    })
    newSeries.push({ data: outcome.serie, name: outcome.name })
    colors.push(outcome.color)
    fillColors.push("#EAF0F4")

    this.setState({
      series: newSeries,
      chartOptions: {
        ...this.state.chartOptions,
        stroke: {
          ...this.state.chartOptions.stroke,
          colors,
        },
        fill: {
          ...this.state.chartOptions.fill,
          colors: fillColors,
        },
        markers: {
          ...this.state.chartOptions.markers,
          colors,
          strokeColor: colors,
        },
      },
      colors,
      fillColors,
    })
  }

  removeLine = (outcome) => {
    const newSeries = []
    const { colors, fillColors } = this.state
    this.state.series.map((s) => {
      newSeries.push({ data: s.data, name: s.name })
    })
    remove(newSeries, (n) => {
      return n.name === outcome.name && n.data === outcome.serie
    })
    const index = colors.indexOf(outcome.color)
    if (index) {
      colors.splice(index, 1)
      fillColors.splice(index, 1)
      this.setState({
        colors,
        series: newSeries,
      })
    }
  }

  render() {
    const { height, width, hasEngagement, data, hasLeader } = this.props
    const { hasEngagementByDivision } = this.state
    return (
      <Fragment>
        <div
          className="WidgetHistoryEvolution-body "
          style={
            hasEngagement || hasEngagementByDivision
              ? { gridTemplateColumns: ".6fr 3.5fr" }
              : { gridTemplateColumns: "1fr 3.5fr" }
          }>
          <div className="section-left">
            <h6 className="subtitle_section">Evolución histórica</h6>
            <div className="variables-description">
              <div style={{ display: "inline-flex" }}>
                <div className="circle-clima" />
                <small> {!hasLeader ? "Clima laboral" : "Liderazgo"} </small>
              </div>
              {(hasEngagement || hasEngagementByDivision) && (
                <div style={{ display: "inline-flex" }}>
                  <div className="circle-clima-engagement" />
                  <small>Engagement</small>
                </div>
              )}
              <div style={{ display: "inline-flex" }}>
                <div className="circle-tasa" />
                <small>Tasa de Respuesta</small>
              </div>
            </div>
          </div>
          <div
            className="section-right"
            style={
              hasEngagement || hasEngagementByDivision
                ? { display: "inline-flex" }
                : {}
            }>
            <div
              className="section-peakon"
              style={
                hasEngagement || hasEngagementByDivision ? { width: "80%" } : {}
              }>
              <Chart
                options={this.state.chartOptions}
                series={this.state.series}
                type="area"
                height={height || 185}
              />
            </div>
            {(hasEngagement || hasEngagementByDivision) && (
              <div
                className="WidgetHistoryEngagement"
                style={{ width: "20%", paddingLeft: "1rem" }}>
                <h6 className="subtitle_section">Outcomes</h6>
                <div className="description">
                  {this.state.outcomes.map((outcome, index) => {
                    return (
                      <div
                        className="row"
                        data-id={outcome.id}
                        onClick={() => {
                          const outcomeFind = this.state.outcomes.find(
                            (outcomeChild) => outcomeChild.id === outcome.id
                          )
                          if (outcomeFind) {
                            const { outcomes } = this.state
                            const showOutcome = outcomeFind.show
                            outcomes[index].show = !showOutcome
                            showOutcome
                              ? this.removeLine(outcomeFind)
                              : this.showLine(outcomeFind)
                            this.setState({ outcomes })
                          }
                        }}>
                        <div
                          style={
                            outcome.show ? { background: outcome.color } : {}
                          }
                          className="circle-engagement"
                        />
                        <small> {outcome.name}</small>
                      </div>
                    )
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </Fragment>
    )
  }
}

WidgetHistoryEvolution.propTypes = {}

export default WidgetHistoryEvolution
